import callQueue from './callQueue'

export default {
  callQueue
}



// WEBPACK FOOTER //
// ./src/components/Sound/index.js